import proserv from './proserv-store.js'

export default { proserv }